<template>
  <span class="inline-flex items-center rounded-full bg-white px-2 py-1 text-sm font-medium text-gray-600 ring-1 ring-inset ring-gray-500">
    <slot />
  </span>
</template>
